<template>
	<div id="app">
    <title>雄安股权交易所</title>
<!--    <meta name="Kyewords" content="雄安股权交易所,河北股权交易所,河北省企业上市培育,河北企业培训,河北融资路演">-->
<!--    <meta name="description" content="雄安股权交易所是经河北省人民政府授权批准设立的河北省行政区域内唯一合法的区域性股权市场运营机构，搭建了涵盖上市培育、股票债券发行、股权登记托管、培训路演等方面的综合金融服务生态体系，先后运营对接深北证券交易所河北服务基地、国家中小企业公共服务示范平台、河北省股改上市服务平台、河北省企业上市服务联盟、全省金融资产交易服务中心和河北省中小企业孵化服务中心">-->
<!--    <router-view></router-view>-->
		<router-view></router-view>
	</div>
</template>

<script>
	import axios from "axios";

  export default {
		name: 'App',
		mounted() {
			// this.$router.afterEach((to, form, next) => {
			// 	window.scrollTo(0, 0)
			// })
      // this.fetchToken()
		},
    methods:{
      fetchToken(){
        this.$request({url:this.$api.public.queryToken}).then((res)=>{
          let token = res.data.message;
          localStorage.setItem("token",token);
          axios.defaults.headers.common['X-Access-Token'] = token;
        })
      }
    }
	}
</script>

<style>
	@font-face {
		font-family: "sourceHans";
		src: url(./assets/font/SourceHanSansCN-Regular.otf);
	}

	* {
		font-family: "sourceHans";
	}

	.ant-carousel .slick-list .slick-slide{
		pointer-events: auto !important;
	}

	.line-1 {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.reback {
		cursor: pointer;
	}

	.reback:hover {
		color: #13B8EE;
	}

	.container {
		width: 1200px;
		margin-left: auto;
		margin-right: auto;
	}

	.justify-around {
		justify-content: space-around;
	}

	.margin-bottom-15 {
		margin-bottom: 15px;
	}

	.margin-left-15 {
		margin-left: 15px;
	}

	.margin-left-10 {
		margin-left: 10px;
	}

	.margin-bottom-30 {
		margin-bottom: 30px;
	}

	.flex {
		display: flex;
	}

	.flex-wrap {
		flex-flow: row wrap;
	}

	.w-90 {
		width: 90px;
	}

	.color-333 {
		color: #333;
	}

	.w-300 {
		width: 400px;
	}

	.align-center {
		align-items: center;
	}

	.align-end {
		align-items: flex-end;
	}

	.justify-between {
		justify-content: space-between;
	}

	.justify-center {
		justify-content: center;
	}

	.text-white {
		color: white;
	}

	.opacity-5 {
		opacity: 0.5;
	}

	.font-18 {
		font-size: 18px;
	}

	.padding-10 {
		padding: 10px;
	}

	.color-999 {
		color: #999 !important;
	}

	.font-14 {
		font-size: 14px;
	}

	.padding-top-10 {
		padding-top: 10px;
	}

	.color-1a {
		color: #1A1A1A !important;
	}

	.margin-left-5 {
		margin-left: 5px;
	}

	.margin-top-30 {
		margin-top: 30px;
	}

	.margin-top-5 {
		margin-top: 5px;
	}

	.text-center {
		text-align: center;
	}

	.margin-top-15 {
		margin-top: 15px;
	}

	.margin-top-10 {
		marign-top: 10px;
	}

	.font-32 {
		font-size: 32px;
	}

	.font-28 {
		font-size: 28px;
	}

	.font-24 {
		font-size: 24px;
	}

	.font-22 {
		font-size: 22px;
	}

	.font-20 {
		font-size: 20px;
	}

	.font-18 {
		font-size: 18px;
	}

	.font-16 {
		font-size: 16px;
	}

	.cover {
		object-fit: cover;
	}

	.w-540 {
		width: 540px;
	}

	.w-395 {
		width: 290px;
	}

	.overflow-eli {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.radius-8 {
		border-radius: 8px;
	}

	.text-bold {
		font-weight: bold;
	}

	.padding-tb-18 {
		padding-top: 18px;
		padding-bottom: 18px;
	}

	.padding-tb-15 {
		padding-top: 16px;
		padding-bottom: 16px;
	}

	.padding-tb-14{
		padding-top: 14px;
		padding-bottom: 14px;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue